import { useSyncExternalStore } from 'react';

import { getTimeFormat, subscribeTimeFormat } from '../utils/dateDisplay';

/**
 * Subscribes the component to the app-wide time display preference ('12h' |
 * '24h'). The twin of useDateFormat, and for the same reason: a control that
 * renders a time (the reminder editor's TimePicker) has to repaint when the
 * preference changes, and it must keep working with no PreferencesProvider
 * above it — the store's default answers then.
 */
export default function useTimeFormat() {
	return useSyncExternalStore(subscribeTimeFormat, getTimeFormat, getTimeFormat);
}
